const AlertPoliciesTypes = {
  SET_ALERT_POLICIES: "alertFactory/alertPolicies/SET_ALERT_POLICIES",
  SET_ALERT_POLICIES_INITIALIZED:
    "alertFactory/alertPolicies/SET_ALERT_POLICIES_INITIALIZED",
};

export default AlertPoliciesTypes;
